import api from './api';

export interface DHSStudyCard {
  _id?: string;
  key: string;
  title: string;
  subtitle: string;
  route: string;
  order?: number;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const dhsStudyService = {
  async getCards(): Promise<DHSStudyCard[]> {
    const res = await api.get('/dhs-study');
    return res.data.data as DHSStudyCard[];
  },
  async createCard(card: DHSStudyCard): Promise<DHSStudyCard> {
    const res = await api.post('/dhs-study', card);
    return res.data.data as DHSStudyCard;
  },
  async updateCard(id: string, updates: Partial<DHSStudyCard>): Promise<DHSStudyCard> {
    const res = await api.put(`/dhs-study/${id}`, updates);
    return res.data.data as DHSStudyCard;
    },
  async deleteCard(id: string): Promise<void> {
    await api.delete(`/dhs-study/${id}`);
  }
};

export default dhsStudyService;
